<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">เพิ่มผู้ดูแลระบบ</h2>
      </div>
      <AdminForm @createAdmin="createAdmin" />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import AdminForm from "@/components/admin/AdminForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    AdminForm,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    createAdmin(data, countryCode) {
      this.loading = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      formData.append("email", data.email);
      formData.append("nameTH", data.nameTh);
      formData.append("surnameTH", data.lastNameTh);
      formData.append("nameEN", data.nameEn);
      formData.append("surnameEN", data.lastNameEn);
      formData.append("titleName", data.prefix);
      formData.append("countryCode", data.countryCode);
      formData.append("mobilephone", data.phoneNumber);
      formData.append("password", data.password);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`admin`, formData, config)
        .then((res) => {

          if (res.data.success) {
            this.$router.push("/admin/list");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createAdmin error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
